module.exports = __webpack_public_path__ + "img/finance6.4f2aeec2.png";